import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Hidden,
  Toolbar,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Theme } from "src/theme";
import { history } from "../../../App";
import Logo from "src/components/Logo";
import { homePath } from "src/utils/paths";

interface TopBarProps {
  className?: string;
  onMobileNavOpen?: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    boxShadow: "none",
    backgroundColor: theme.palette.primary.main,
  },
  toolbar: {
    marginTop: 16,
    minHeight: 64,
  },
  title: {
    marginLeft: theme.spacing(2),
  },
  logo: {
    height: 32,
  },
}));

const TopBar: React.FC<TopBarProps> = ({
  className,
  onMobileNavOpen,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Hidden smUp>
      <Toolbar className={classes.toolbar}>
        <Logo
          small
          className={classes.logo}
          onClick={() => history.push(homePath)}
        />
        <Typography
          onClick={() => history.push(homePath)}
          variant="button"
          style={{
            marginLeft: "1rem",
            textTransform: "unset",
            textDecoration: "none",
          }}
        >
          BRITA Water Map
        </Typography>
        <Box ml={2} flexGrow={1} />
        {/* <Box ml={2}>
          <Account />
        </Box> */}
      </Toolbar>
    </Hidden>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {},
};

export default TopBar;
